import { Component } from '@angular/core';

@Component({
    selector: 'app-brand-guidelines',
    templateUrl: './brand-guidelines.component.html',
    standalone: false
})
export class BrandGuidelinesComponent {}
